<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important" toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Minutes Of Meeting</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <md-layout md-gutter>
                <b-col md="3">
                  <label>
                    Meeting Attendend by Pridel Side
                    <span class="error">*</span>
                  </label>
                  <multi-select :options="$store.getters['common/getAllMultiUserList']"
                    :selected-options="PridelSideUser_items" v-model="leadForm.fk_lead_pridel_user_id"
                    placeholder="Select Pridel Side User" :multiple="true" id="fk_lead_pridel_user_id"
                    @select="SelectMultiPridelSideUser"></multi-select>

                  <!-- <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllUserList']"
                    id="lead_pridel_user"
                    v-model="leadForm.fk_lead_pridel_user_id"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Pridel Side User"
                  ></model-list-select> -->
                  <span class="error" v-if="!leadForm.fk_lead_pridel_user_id">
                    {{ errorList.fk_lead_pridel_user_id }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Meeting Attendend by Lead Side
                    <span class="error">*</span>
                  </label>
                  <multi-select :options="$store.getters['common/getAllMultiLeadUserList']"
                    :selected-options="LeadSideUser_items" v-model="leadForm.lead_user"
                    placeholder="Select Lead Side User" :multiple="true" id="lead_user"
                    @select="SelectMultiLeadSideUser"></multi-select>
                  <!-- <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllLeadUserList']"
                    id="lead_user"
                    v-model="leadForm.lead_user"
                    option-value="lead_name"
                    option-text="lead_name"
                    placeholder="Select Lead Side User"
                  ></model-list-select> -->
                  <span class="error" v-if="!leadForm.lead_user">
                    {{ errorList.lead_user }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Other Lead Side User
                    <span class="error"></span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="lead_name" name="lead_name"
                    v-model="leadForm.other_lead_user_name" placeholder="`Please Enter Other Lead User Name"
                    type="text"></b-form-input>
                  <span class="error" v-if="!leadForm.other_lead_user_name">
                    {{ errorList.other_lead_user_name }}
                  </span>
                </b-col>

                <!-- <b-col md="12">
                  <b>Add Members</b>
                  <b-button @click="addMultiLead()" size="sm">
                    <i class="fa fa-plus-circle ml-1"></i>
                  </b-button>
                </b-col>
                <b-col md="12" v-for="(ld_item, ld_index) in multiLeadArr" :key="ld_index">
                  <b-col md="3">
                    <label>
                      Account {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <model-list-select
                      :list="accountList"
                      id="lead_account"
                      v-model="ld_item.lead_account"
                      option-value="value"
                      option-text="text"
                      :placeholder="`Please Select Account Type ${ld_index + 1}`"
                    ></model-list-select>
                    <span class="error" v-if="!ld_item.lead_account">
                      {{
                      ld_item.lead_account_err
                      }}
                    </span>
                  </b-col>
                  <b-col md="3">
                    <label>
                      Name {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="lead_name"
                      name="lead_name"
                      v-model="ld_item.lead_name"
                      :placeholder="`Please Enter Name ${ld_index + 1}`"
                      type="text"
                    ></b-form-input>
                    <span class="error" v-if="!ld_item.lead_name">
                      {{
                      ld_item.lead_name_err
                      }}
                    </span>
                  </b-col>
                  <b-col md="3">
                    <label>
                      Email {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="lead_email"
                      name="lead_email"
                      v-model="ld_item.lead_email"
                      :placeholder="`Please Enter Email ID ${ld_index + 1}`"
                      type="email"
                    ></b-form-input>
                    <span class="error" v-if="!ld_item.lead_email">
                      {{
                      ld_item.lead_email_err
                      }}
                    </span>
                  </b-col>
                  <b-col md="2">
                    <label>
                      Mobile {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="lead_mobile"
                      name="lead_mobile"
                      v-model="ld_item.lead_mobile"
                      :placeholder="`Please Enter Mobile No. ${ld_index + 1}`"
                      type="number"
                    ></b-form-input>
                    <span class="error" v-if="!ld_item.lead_mobile">
                      {{
                      ld_item.lead_mobile_err
                      }}
                    </span>
                  </b-col>
                  <b-col md="1">
                    <b-button
                      class="mt-5"
                      v-if="ld_index > 0"
                      size="sm"
                      @click="removeMultiLead(ld_index)"
                    >
                      <i class="fa fa-minus-circle" aria-hidden="true"></i>
                    </b-button>
                  </b-col>
                </b-col> -->

                <b-col md="3">
                  <label>
                    Date Time
                    <span class="error">*</span> </label><br />
                  <date-picker lang="en" name="lead_DateTime" id="lead_DateTime" type="datetime"
                    format="YYYY-MM-DD hh:mm a" :minute-step="1" v-model="leadForm.lead_DateTime"></date-picker><br />
                  <span class="error" v-if="!leadForm.lead_DateTime">
                    {{ errorList.lead_DateTime }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Venue
                    <span class="error">*</span>
                  </label>
                  <b-textarea :formatter="capitalizeAll" id="lead_venue" name="lead_venue" type="text"
                    v-model="leadForm.lead_venue" placeholder="Please Enter Venue"></b-textarea>
                  <span class="error" v-if="!leadForm.lead_venue">
                    {{ errorList.lead_venue }}
                  </span>
                </b-col>

                <!-- <b-col md="3">
                  <label>
                    CTA
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_cta"
                    name="lead_cta"
                    v-model="leadForm.lead_cta"
                    placeholder="Please Enter CTA"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_cta">
                    {{ errorList.lead_cta }}
                  </span>
                </b-col> -->

                <b-col md="12">
                  <label>
                    Minutes of Meeting
                    <span class="error">*</span>
                  </label>
                  <b-textarea :formatter="capitalizeAll" id="lead_minutes_of_meeting" name="lead_minutes_of_meeting"
                    type="text" v-model="leadForm.lead_minutes_of_meeting" placeholder="Please Enter Minutes of Meeting"
                    rows="5"></b-textarea>
                  <span class="error" v-if="!leadForm.lead_minutes_of_meeting">
                    {{ errorList.lead_minutes_of_meeting }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Further Action
                    <span class="error">*</span>
                  </label>
                  <model-list-select :list="furtoreAction" id="lead_further_action"
                    v-model="leadForm.lead_further_action" option-value="value" option-text="text"
                    :placeholder="`Please Select Further Action`"></model-list-select>
                  <span class="error" v-if="!leadForm.lead_further_action">
                    {{ errorList.lead_further_action }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Followup Date
                    <span class="error">*</span> </label><br />
                  <date-picker lang="en" name="lead_followupdate" id="lead_followupdate" type="date" format="YYYY-MM-DD"
                    :minute-step="1" v-model="leadForm.lead_followupdate"></date-picker><br />
                  <span class="error" v-if="!leadForm.lead_followupdate">
                    {{ errorList.lead_followupdate }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Followup Time
                    <span class="error">*</span> </label><br />
                  <date-picker lang="en" name="lead_followupTime" id="lead_followupTime" type="time" format="hh:mm a"
                    :minute-step="1" v-model="leadForm.lead_followupTime"></date-picker><br />
                  <span class="error" v-if="!leadForm.lead_followupTime">
                    {{ errorList.lead_followupTime }}
                  </span>
                </b-col>
                <div class="col-md-3">
                  <label>Assign To</label>
                  <multi-select :options="$store.getters['common/getAllMultiUserList']"
                    :selected-options="AssignedUser_items" v-model="leadForm.assigned_user"
                    placeholder="Select Assign To" :multiple="true" id="assigned_user"
                    @select="SelectMultiAssignedUser"></multi-select>
                </div>
                <b-col md="3">
                  <label>
                    Remark
                    <span class="error"></span>
                  </label>
                  <b-textarea :formatter="capitalizeAll" id="lead_remark" name="lead_remark" type="text"
                    v-model="leadForm.lead_remark" placeholder="Please Enter Remark" rows="5"></b-textarea>
                  <span class="error" v-if="!leadForm.lead_remark">
                    {{ errorList.lead_remark }}
                  </span>
                </b-col>
                <hr />
              </md-layout>
            </div>
            <div>
              <b-col md="3"></b-col>
              <b-col md="3">
                <b-button size="sm" class="pull-right mt-2" style="margin:left:5px" variant="primary"
                  @click="addMinutesMeeting">Save</b-button>
              </b-col>
              <b-col md="3"></b-col>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vue2-editor/dist/vue2-editor.umd.min.js"></script>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
import LeadService from "../../services/LeadService.js";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("edit_lead_id") != undefined &&
      this.$sessionsStorage.get("edit_lead_id") != null &&
      this.$sessionsStorage.get("edit_lead_id") != ""
    ) {
      // alert(this.$sessionsStorage.get("edit_lead_id"))
      this.getSingleMinutesOfMeeting(this.$sessionsStorage.get("edit_lead_id")),
        this.$sessionsStorage.get("edit_track_id");
    }
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllLeadUserList",
      JSON.stringify({
        itemCode: "GET_LEADUSERLIST_Data",
        lead_id: this.$sessionsStorage.get("edit_lead_id"),
      })
    );

    this.$store.dispatch(
      "common/setAllMultiUserList",
      JSON.stringify({
        itemCode: "GET_MULTI_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllMultiLeadUserList",
      JSON.stringify({
        itemCode: "GET_MULTI_LEADUSERLIST_Data",
        lead_id: this.$sessionsStorage.get("edit_lead_id"),
      })
    );
    if (globalPermissionStatus("Lead")) {
      this.$store.dispatch("setCurrentRoute", "/lead/upsertLead");
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    AutoContainerType: {
      handler: function (newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true,
    },
  },
  data() {
    return {
      LeadSideUser_items: [],
      PridelSideUser_items: [],
      AssignedUser_items: [],
      minutes_of_meeting_details: [],
      AddressArr: [],
      multiLeadArr: [
        {
          lead_name: "",
          lead_email: "",
          lead_mobile: "",
          lead_account: "",
          lead_name_err: "",
          lead_email_err: "",
          lead_mobile_err: "",
          lead_account_err: "",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      leadForm: {
        lead_id: "",
        track_id: "",
        fk_lead_pridel_user_id: "",
        lead_pridel_user: "",
        lead_user: "",
        lead_user_txt: "",
        other_lead_user_name: "",
        lead_venue: "",
        lead_DateTime: "",
        lead_minutes_of_meeting: "",

        lead_further_action: "",
        lead_followupdate: "",
        lead_followupTime: "",
        lead_remark: "",
        assigned_user: "",
        assigned_user_txt: "",
        assigned_user_email: "",
        // lead_cta: "",
      },
      leadFormError: [
        "Please Select Pridel Side User",
        "Please Select Lead Side User",
        "Please Enter Venue",
        "Please Enter Date Time",
        "Please Enter Minutes Of Meeting",
        // "Please Enter Lead CTA",
        "Please Select Further Action",
        "Please Select Followup Date",
        "Please Select Followup Time",
      ],
      errorList: {
        fk_lead_pridel_user_id: "",
        lead_user: "",
        lead_further_action: "",
        lead_venue: "",
        lead_DateTime: "",
        lead_minutes_of_meeting: "",
        // lead_cta: "",
        lead_further_action: "",
        lead_followupdate: "",
        lead_followupTime: "",
        lead_remark: "",
        // assigned_user: "",
      },
      selectDateFormat,
      furtoreAction: [
        {
          text: "CALL",
          value: "CALL",
        },
        {
          text: "EMAIL",
          value: "EMAIL",
        },
        {
          text: "IN PERSON",
          value: "IN PERSON",
        },
      ],

      isLoading: false,
      validate: false,

      docURL: URL_BASE_DOC,
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleLead() {
      return this.leadForm.lead_id != "" ? true : false;
    },
  },
  methods: {
    SelectMultiPridelSideUser(PridelSideUser_items, lastSelectItem) {
      this.PridelSideUser_items = PridelSideUser_items;
      this.leadForm.fk_lead_pridel_user_id = PridelSideUser_items;
      if (PridelSideUser_items.length == 0) {
        this.PridelSideUser_items = [];
        this.leadForm.fk_lead_pridel_user_id = "";
      }
      console.log(this.PridelSideUser_items);
    },
    SelectMultiLeadSideUser(LeadSideUser_items, lastSelectItem) {
      this.LeadSideUser_items = LeadSideUser_items;
      this.leadForm.lead_user = LeadSideUser_items;
      if (LeadSideUser_items.length == 0) {
        this.LeadSideUser_items = [];
        this.leadForm.lead_user = "";
      }
    },
    SelectMultiAssignedUser(AssignedUser_items, lastSelectItem) {
      this.AssignedUser_items = AssignedUser_items;
      this.leadForm.assigned_user = AssignedUser_items;
      if (AssignedUser_items.length == 0) {
        this.AssignedUser_items = [];
        this.leadForm.assigned_user = "";
        this.leadForm.assigned_user_email = "";
      }
      console.log(this.AssignedUser_items);
    },
    goBack() {
      window.history.go(-1);
    },
    setLeadDetails(item, lead_id) {
      let lead_details = item;
      if (lead_id != undefined && lead_id != null && lead_id != "") {
        this.leadForm = {
          lead_id: "",
          track_id: "",
          fk_lead_pridel_user_id: "",
          lead_pridel_user: "",
          lead_user: "",
          other_lead_user_name: "",
          lead_venue: "",
          lead_DateTime: "",
          lead_minutes_of_meeting: "",
          lead_cta: "",
          lead_further_action: "",
          lead_followupdate: "",
          lead_followupTime: "",
          lead_remark: "",
          assigned_user: "",
          assigned_user_txt: "",
          assigned_user_email: "",
        };
      } else {
        this.leadForm = {
          lead_id: lead_details.fk_lead_id,
          track_id: lead_details.track_id,
          fk_lead_pridel_user_id: lead_details.fk_lead_pridel_user_id,
          lead_pridel_user: lead_details.lead_pridel_user,
          lead_user: lead_details.lead_user,
          other_lead_user_name: lead_details.other_lead_user_name,
          lead_venue: lead_details.lead_venue,
          lead_DateTime: lead_details.lead_DateTime,
          lead_minutes_of_meeting: lead_details.lead_minutes_of_meeting,
          lead_cta: lead_details.lead_cta,

          lead_further_action: lead_details.lead_further_action,
          lead_followupdate: lead_details.lead_followupdate,
          lead_followupTime: lead_details.lead_followupTime,
          lead_remark: lead_details.lead_remark,
          assigned_user: lead_details.assigned_user,
          assigned_user_txt: lead_details.assigned_user_txt,
          assigned_user_email: lead_details.assigned_user_email,
        };
      }
    },

    addMultiLead() {
      let obj = {
        lead_name: "",
        lead_email: "",
        lead_mobile: "",
        lead_account: "",
        lead_name_err: "",
        lead_email_err: "",
        lead_mobile_err: "",
        lead_account_err: "",
      };
      this.multiLeadArr.push(obj);
    },
    removeMultiLead(index) {
      this.multiLeadArr.splice(index, 1);
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    validateLeads() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.leadForm[x] == "" ||
          this.leadForm[x] == undefined ||
          this.leadForm[x] == null
        ) {
          this.errorList[x] = this.leadFormError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addMinutesMeeting() {
      // replace( /[\r\n]+/gm, "" )
      // this.$store.getters["common/getAllUserList"].forEach((element) => {
      //   if (element.userId == this.leadForm.fk_lead_pridel_user_id) {
      //     return (this.leadForm.lead_pridel_user = element.employeeName);
      //   }
      // });

      this.leadForm.fk_lead_pridel_user_id = "";
      this.leadForm.lead_pridel_user = "";
      this.leadForm.lead_user = "";
      this.leadForm.lead_user_txt = "";

      this.leadForm.assigned_user = "";
      this.leadForm.assigned_user_txt = "";
      this.leadForm.assigned_user_email = "";
      if (!this.leadForm.fk_lead_pridel_user_id) {
        this.leadForm.fk_lead_pridel_user_id = "";
        this.leadForm.lead_pridel_user = "";
        this.PridelSideUser_items.forEach((item_val) => {
          if (this.leadForm.fk_lead_pridel_user_id) {
            this.leadForm.lead_pridel_user =
              this.leadForm.lead_pridel_user + "," + item_val.text;
            this.leadForm.fk_lead_pridel_user_id =
              this.leadForm.fk_lead_pridel_user_id + "," + item_val.value;

            // this.leadForm.assigned_user_email =
            // this.leadForm.assigned_user_email + "," + item_val.email;
          } else {
            this.leadForm.lead_pridel_user = item_val.text;
            this.leadForm.fk_lead_pridel_user_id = item_val.value;
            // this.leadForm.assigned_user_email = item_val.email;
          }
        });
      }

      if (!this.leadForm.lead_user) {
        this.leadForm.lead_user = "";
        this.leadForm.lead_user_txt = "";
        this.LeadSideUser_items.forEach((item_val) => {
          if (this.leadForm.lead_user) {
            this.leadForm.lead_user_txt =
              this.leadForm.lead_user_txt + "," + item_val.text;
            this.leadForm.lead_user = this.leadForm.lead_user + "," + item_val.value;
          } else {
            this.leadForm.lead_user_txt = item_val.text;
            this.leadForm.lead_user = item_val.value;
          }
        });
      }

      if (!this.leadForm.assigned_user) {
        this.leadForm.assigned_user = "";
        this.leadForm.assigned_user_txt = "";
        this.AssignedUser_items.forEach((item_val) => {
          if (this.leadForm.assigned_user) {
            this.leadForm.assigned_user_txt =
              this.leadForm.assigned_user_txt + "," + item_val.text;
            this.leadForm.assigned_user =
              this.leadForm.assigned_user + "," + item_val.value;
            this.leadForm.assigned_user_email =
              this.leadForm.assigned_user_email + "," + item_val.email;
          } else {
            this.leadForm.assigned_user_txt = item_val.text;
            this.leadForm.assigned_user = item_val.value;
            this.leadForm.assigned_user_email = item_val.email;
          }
        });
      }
      console.log("leadForm=>", this.leadForm);
      console.log("errorList=>", this.errorList);
      // return false;
      this.validateLeads();
      if (this.validate == false) return false;
      this.isLoading = true;
      let payload = {
        itemCode: "addMinutesMeeting",
        leadForm: this.leadForm,
        TypeofAdd: "Add Lead Track Master",
        lead_id: this.$sessionsStorage.get("edit_lead_id"),
      };
      console.log("payload=>", payload);
      // return false;
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        LeadService.getAllLeadList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.lead_id != "" && data.lead_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              if (data.flag == true) {
                this.$router.push({
                  path: "/lead/leadlist",
                });
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },

    getSingleMinutesOfMeeting(id, track_id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_Leads",
        lead_id: id,
        track_id: track_id,
      };
      LeadService.getAllLeadList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.leadForm = data.singleLead;
            this.setLeadDetails(data.singleLead, data.singleLead.lead_id);
            console.log(" Single Lead response=>", data);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },

    previousFFView() {
      window.history.go(-1);
    },
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// leadTrack.vue?7f6c3e20